<template>
  <CCard style="position: sticky; top: 5rem">
    <CCardHeader class="px-3 py-2">
      <i class="fas fa-filter"></i>&nbsp;
      <strong>Filter</strong>
    </CCardHeader>
    <CCardBody class="filter-content p-3">
      <div class="form-row align-items-center">
        <div class="col-auto">
          <CSwitch
            :checked.sync="isMine"
            shape="pill"
            variant="opposite"
            size="sm"
            color="info"
            @update:checked="isMineChange"
          />
        </div>
        <div class="col-auto">
          <span class="mb-2" style="color: #007bff">My Ideas</span>
        </div>
      </div>

      <hr />
      <div>
        <p><strong>Status</strong></p>
        <div
          v-for="(item, i) in statuses"
          :key="`status-${i}`"
          class="custom-control custom-checkbox mb-1"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            v-model="status"
            :id="`status-${i}`"
            name="Status"
            :value="item.value"
            @change="statusChange"
          />
          <label
            class="custom-control-label d-block"
            :for="`status-${i}`"
            style="line-height: 1rem"
          >
            <CBadge :color="item.color" class="px-2 py-1 mr-2">
              {{ item.text.toUpperCase() }}
            </CBadge>

            <CBadge :color="item.color" class="px-1 py-1 float-right">
              {{ statusCount[item.value] }}
            </CBadge>
          </label>
        </div>
      </div>

      <hr />
      <div>
        <p><strong>Topic</strong></p>
        <div
          v-for="(item, i) in areas"
          :key="`area-${i}`"
          class="custom-control custom-checkbox mb-1"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            v-model="area"
            :id="`area-${i}`"
            name="Area"
            :value="item.value"
            @change="areaChange"
          />
          <label :class="`custom-control-label`" :for="`area-${i}`">
            {{ item.text }}
          </label>
        </div>
      </div>

      <hr />
      <div>
        <p><strong>Likes</strong></p>
        <div>
          <div>
            <div>
              <label>From {{ likeFrom }}</label
              ><br />
              <range-slider
                v-model="likeFrom"
                class="slider w-100"
                min="0"
                max="99"
                step="1"
                @change="likeFromChange"
              >
              </range-slider>
            </div>

            <div>
              <label>To {{ likeTo }}{{ likeTo == 99 ? "+" : "" }}</label
              ><br />
              <range-slider
                v-model="likeTo"
                class="slider w-100"
                :min="likeFrom"
                max="99"
                step="1"
                @change="likeToChange"
              >
              </range-slider>
            </div>
          </div>
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import RangeSlider from "vue-range-slider";
// you probably need to import built-in style
import "vue-range-slider/dist/vue-range-slider.css";

export default {
  components: {
    RangeSlider,
  },
  props: ["queryObject"],
  data() {
    return {
      isMine: false,
      area: [],
      status: [],
      areas: [],
      likeFrom: 0,
      likeTo: 0,
      routeName: "Idea",
      timeoutQuery: null,
      statusCount: {},
    };
  },
  mounted() {
    this.getAreas();

    this.loadSelectedFilter(this.queryObject);

    this.loadStatusCount();
  },
  computed: {
    statuses() {
      let states = this.$const.IDEA_STATUS_TEXT;
      return Object.keys(states).map((_) => {
        return {
          value: _,
          text: states[_].text,
          color: states[_].color,
        };
      });
    },
  },
  watch: {
    queryObject(val) {
      if (this.timeoutQuery) {
        clearTimeout(this.timeoutQuery);
      }
      this.timeoutQuery = setTimeout(() => {
        this.loadSelectedFilter(val);
      }, 500);
    },
  },
  methods: {
    async getAreas() {
      let result = [];
      let resp = await this.$http.get("/odata/SipArea", {
        params: {
          $select: "Id,Name",
          $filter: `Status eq ${this.$const.STATUS.Active}`,
          $orderby: `DisplayOrder asc`,
        },
      });
      if (resp && resp.status == 200 && resp.data.value.length) {
        result = resp.data.value.map((_) => {
          return {
            value: _.Id,
            text: _.Name,
          };
        });
      }
      this.areas = result;
    },

    pushRouter(isMine, status, area, likeFrom, likeTo, hash) {
      let query = this.queryObject;
      let routeName = this.routeName;
      query["isMine"] = isMine;
      query["status"] = status;
      query["area"] = area;
      query["likeFrom"] = likeFrom;
      query["likeTo"] = likeTo;
      query["page"] = "1";
      this.$router
        .push({
          name: routeName,
          query: query,
          hash: hash ? hash : "",
        })
        .catch(() => {});
    },

    loadSelectedFilter(queryObj) {
      if (queryObj) {
        if (JSON.stringify(queryObj.status) != JSON.stringify(this.status)) {
          this.status = queryObj.status ?? [];
        }
        if (JSON.stringify(queryObj.area) != JSON.stringify(this.area)) {
          this.area = queryObj.area ?? [];
        }
        if (
          JSON.stringify(queryObj.likeFrom) != JSON.stringify(this.likeFrom)
        ) {
          this.likeFrom = queryObj.likeFrom;
        }
        if (JSON.stringify(queryObj.likeTo) != JSON.stringify(this.likeTo)) {
          this.likeTo = queryObj.likeTo;
        }
        if (JSON.stringify(queryObj.isMine) != JSON.stringify(this.isMine)) {
          this.isMine = queryObj.isMine == "true" ? true : false;
        }
      } else {
        this.status = [];
        this.area = [];
        this.likeFrom = 0;
        this.likeTo = 0;
        this.isMine = false;
      }
    },

    isMineChange(val) {
      this.pushRouter(
        val,
        this.status,
        this.area,
        this.likeFrom,
        this.likeTo,
        "#ismine"
      );
    },

    statusChange() {
      this.pushRouter(
        this.isMine,
        this.status,
        this.area,
        this.likeFrom,
        this.likeTo,
        "#status"
      );
    },

    areaChange() {
      this.pushRouter(
        this.isMine,
        this.status,
        this.area,
        this.likeFrom,
        this.likeTo,
        "#area"
      );
    },

    likeFromChange() {
      let val = this.likeFrom;
      if (this.likeTo < val) {
        this.likeTo = val;
      }
      this.pushRouter(
        this.isMine,
        this.status,
        this.area,
        val,
        this.likeTo,
        "#like"
      );
    },

    likeToChange() {
      this.pushRouter(
        this.isMine,
        this.status,
        this.area,
        this.likeFrom,
        this.likeTo,
        "#like"
      );
    },

    async loadStatusCount() {
      let statuses = this.statuses;
      let statusCount = {};
      await this.$func.asyncForEach(statuses, async (item) => {
        let count = 0;
        let resp = await this.$http.get(`odata/SipIdea`, {
          params: {
            $top: 0,
            $count: true,
            $filter: `Status eq ${item.value} and SipIdeaOfChallenges/any() eq false`,
          },
        });
        if (resp && resp.status == 200) {
          count = resp.data["@odata.count"];
        }
        statusCount[item.value] = count;
      });
      this.statusCount = statusCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-content {
  overflow-y: auto;
  max-height: calc(100vh - 9rem);
}
</style>
